<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">Components</p>
        <h1 class="dg-header">Buttons</h1>
        <p>Buttons serve as interactive components that perform a specified action when clicked. Buttons should be clear in their function and facilitate simple task completion for the user.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <div class="row">
          <div class="col mb-4">
            <p class="h3 dg-subheader">Examples</p>
              <ComponentExample>
                <template slot="ui-example">
                  <div v-html="docs.usage.componentExample"></div>
                </template>
              <template slot="code-example">
                <som-tabs>
                  <som-tab name="Component">
{{docs.usage.componentExample}}
                  </som-tab>
                  <som-tab name="HTML">
{{docs.usage.htmlExample}}
                   </som-tab>
                </som-tabs>
              </template>
              <template slot="link">
                <a href="https://codepen.io/emichigan/pen/yKKjRR" class="edit-link btn btn-primary btn-sm" target="_blank">Edit on Codepen</a>
              </template>
            </ComponentExample>
          </div>
        </div>

        <ComponentDoc :docs="docs"></ComponentDoc>
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
import VueMarkdown from 'vue-markdown';
import ComponentExample from "../ComponentExample";
import ComponentDoc from "../ComponentDoc";
import Docs from '../../../static/docs.json';

export default {
  name: "Buttons",
  components: {
    VueMarkdown,
    ComponentExample,
    ComponentDoc
  },
  mounted: function() {
    const loadingBtn = document.getElementById('loadingBtn');
    toggleLoad();

    function toggleLoad() {
      loadingBtn.loading = !loadingBtn.loading;

      setTimeout(function() {
        toggleLoad();
      }, 3000);
    }
  },
  data: function() {
    return {
      docs: Docs.components.find(component => component.tag === 'som-button')
    }
  } 
};

</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
som-tab {
  overflow-x: scroll;
  overflow-y: hidden;
}
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Buttons.vue